import React, { useEffect, useState } from 'react';
import { BACKEND_URL } from '../../config';
import { AlertsToggle } from '../sim/AlertsToggle';
import { GettingStarted, TradePlan, PractiseFirst, PropFirms, Extras } from './GuideSections';
import { Section, B } from './GuideParts';
import '../sim/sim.css';

const useFirstName = () => {
  const [name, setName] = useState('');
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/user/profile`, { headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` } })
      .then((r) => r.json())
      .then((d) => setName(((d.user && d.user.full_name) || '').trim().split(/\s+/)[0] || ''))
      .catch(() => {});
  }, []);
  return name;
};

// 📖 How to Trade Blindfolded — user guide modal.
export const BlindfoldedGuide = ({ onClose }) => {
  const name = useFirstName();
  return (
    <div data-testid="strategy-guide-modal" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', zIndex: 9999, padding: '1rem', overflowY: 'auto' }}>
      <div style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', borderRadius: '16px', maxWidth: '720px', width: '100%', margin: '2rem auto', border: '2px solid rgba(251,191,36,0.5)', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
        <div style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', padding: '1.25rem 1.5rem', borderRadius: '14px 14px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, color: '#1a1a2e', fontSize: '1.4rem', fontWeight: 700 }}>📖 How to Trade Blindfolded</h2>
          <button type="button" onClick={onClose} data-testid="guide-close-x" aria-label="Close guide" style={{ background: 'rgba(0,0,0,0.2)', border: 'none', borderRadius: '50%', width: 36, height: 36, cursor: 'pointer', fontSize: '1.1rem', color: '#1a1a2e' }}>✕</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <Section testId="guide-welcome">
            <p data-testid="guide-greeting" style={{ fontSize: '1.15rem', margin: '0 0 0.5rem' }}>Hi <B>{name || 'Trader'}</B> 👋</p>
            <p style={{ margin: '0 0 0.5rem' }}>Welcome to <B>tradeblindfolded.com</B>.</p>
            <p style={{ margin: '0 0 0.5rem' }}>This website was built to make trading so easy that you can do it blindfolded. It's as simple as receiving a phone notification and setting the trade.</p>
            <p style={{ margin: 0 }}><B>Trade Blindfolded</B> means trusting our alerts without needing to analyse charts yourself. When you receive a notification, you can enter the trade confidently, knowing the system has already done the analysis for you.</p>
          </Section>
          <Section title="🎓 What the protocol lets you do" testId="guide-purpose">
            <ol style={{ margin: 0, paddingLeft: '1.25rem', display: 'grid', gap: '0.5rem' }}>
              <li><B>Learn how to trade on this website</B> by placing trades in simulated trading conditions using <B>LIVE</B> market data. No real money is at risk.</li>
              <li><B>Get familiar with the protocol</B> and build confidence in its ability before you trade prop firm accounts.</li>
            </ol>
          </Section>
          <GettingStarted alertsButton={<AlertsToggle />} />
          <TradePlan />
          <PractiseFirst />
          <PropFirms />
          <Extras />
          <div style={{ textAlign: 'center' }}>
            <button type="button" onClick={onClose} data-testid="guide-got-it-btn" style={{ padding: '0.75rem 2rem', background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', color: '#1a1a2e', border: 'none', borderRadius: '999px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>Got It! 👍</button>
          </div>
        </div>
      </div>
    </div>
  );
};
